import AppLoader from 'components/common/AppLoader';
import useAbsoluteUrl from 'components/Hooks/useAbsoluteUrl';
import Helmet from 'react-helmet';

const NotFound = () => {
    const url = useAbsoluteUrl();

    return <>
        <Helmet>
            <title>404 - Page Not Found</title>
            <meta name="errorpage" content="true" />
            <meta name="errortype" content="404 - Not Found" />
            <meta name="description" content="Page not found." />
            <link rel="canonical" href={url('/404')} />
            <meta name="robots" content="noindex" />
        </Helmet>
        <AppLoader message="Page not found" />
    </>;
};

export default NotFound;
